module.exports = __webpack_public_path__ + "img/drone-montagne.bafef8f4.jpg";